import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { MatDialog } from '@angular/material/dialog';
import { GbpReviewDetailDrawerComponent } from './review-detail-drawer.component';

@Component({
  selector: 'app-gbp-reviews-inbox',
  templateUrl: './reviews-inbox-page.component.html',
  styleUrls: ['./reviews-inbox-page.component.css'],
})
export class GbpReviewsInboxComponent implements OnInit {
  url: string = 'gbpReviews/inbox';
  data: Array<any> = [];
  locations: Array<any> = [];
  totalReviews = '';

  // Filters
  ratingMin: number | null = null;
  ratingMax: number | null = null;
  replyStatus: string = '';
  locationId: string = '';
  hasComment: boolean = true;

  currentPage: number = 1;
  totalPages: number = 1;
  limit: number = 20;

  morePages: boolean = true;
  itemsPerPage: number = 15;
  stars: number[] = [1, 2, 3, 4, 5];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private dialog: MatDialog,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.getLocations();
    this.getData();
  }

  getLocations() {
    this.dataService.getData('gbpLocations').subscribe((res) => {
      if (res.rst) this.locations = res.data;
    });
  }

  getData(): void {
    let query = `?page=${this.currentPage}&limit=${this.limit}`;
    if (this.ratingMin) query += `&ratingMin=${this.ratingMin}`;
    if (this.ratingMax) query += `&ratingMax=${this.ratingMax}`;
    if (this.replyStatus) query += `&replyStatus=${this.replyStatus}`;
    if (this.locationId) query += `&locationId=${this.locationId}`;
    if (this.hasComment) query += `&hasComment=1`;

    this.dataService.getData(this.url + query).subscribe((response) => {
      console.log('response', response);
      if (response && response.rst) {
        this.data = response.data;
        this.totalPages = response.pages;
        this.totalReviews = response.total;
      }
    });
  }

  setRatingFilter(min: number | null, max: number | null) {
    this.ratingMin = min;
    this.ratingMax = max;
    this.currentPage = 1;
    this.getData();
  }

  setReplyStatus(status: string) {
    this.replyStatus = status;
    this.currentPage = 1;
    this.getData();
  }

  setLocation(id: string) {
    this.locationId = id;
    this.currentPage = 1;
    this.getData();
  }

  openDetail(review: any) {
    const dialogRef = this.dialog.open(GbpReviewDetailDrawerComponent, {
      width: '600px',
      position: { right: '0' },
      height: '100vh',
      panelClass: 'side-drawer',
      data: { review },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getData();
    });
  }

  changePage(page: number) {
    this.currentPage = page;
    this.getData();
  }
}
